import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop - Centralized Scroll Restoration Controller
 * 
 * Governance:
 * - Detects route changes via pathname
 * - Scrolls to top instantly on navigation
 * - Ignores hash-based navigation (allows anchor links)
 * - Runs once per route change
 * 
 * Rules:
 * - No smooth scrolling (feels artificial on page navigation)
 * - Does not interfere with browser back/forward
 * - Single centralized solution at router level
 */

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash, allow default browser anchor behavior
    if (hash) {
      return;
    }

    // Scroll to top instantly on route change
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
